import { makeVar } from '@apollo/client';

export type AppSnack = {
  id: number;
  severity: 'success' | 'error' | 'info' | 'warning';
  message: string;
  dismissed?: boolean;
};

export const appSnacksVar = makeVar<AppSnack[]>([]);
